import { useCallback } from "react";
import { ProductionFulfillmentApi, useAPIAction } from "melco-shared-logic";

export const useDeleteDesignMappings = () => {
  const [deleteDesignMapping] = useAPIAction(
    ProductionFulfillmentApi,
    async (api, id: string) => {
      const data = await api.productionFulfillmentMappingsDelete({ id });

      return {
        successMessages: [{ message: "default" }],
        data,
      };
    },
    {
      translationPrefix: "designMappings.actions.delete",
    }
  );

  return useCallback(
    async (inputFormatIds: string[]) => {
      const successfullyDeleted: string[] = [];

      for (const inputFormatId of inputFormatIds) {
        try {
          await deleteDesignMapping(inputFormatId);
          successfullyDeleted.push(inputFormatId);
        } catch (e) {
          // error handling is already done in useAPIAction
        }
      }

      return successfullyDeleted;
    },
    [deleteDesignMapping]
  );
};
